import { PolicyLinkPlacement, LinkType } from "../../modules/enums";
import { IPolicy } from "../../modules/components";

export const RefundPolicies: IPolicy[] = [
  {
    title: `Eligibility for Refunds`,
    description: `Refunds may be issued under the following circumstances:`,
    extras: [
      {
        title: `Service Not Delivered`,
        description: `If a trip or service is cancelled by truQ or our partner before commencement and no alternative arrangement is provided.`,
      },
      {
        title: `Service Failure`,
        description: `If the assigned transporter fails to complete the trip due to reasons attributable to truQ or our partners.`,
      },
      {
        title: `Overpayment or Duplicate Payment`,
        description: ` If you are charged more than once for the same service, the excess payment will be refunded.`,
      },
      {
        title: `Cancelled Trips (Pre-dispatch)`,
        description: `If you cancel a trip before a driver/vehicle has been dispatched, you are eligible for a full refund.`,
      },
    ],
  },
  {
    title: `Non-Refundable Circumstances`,
    description: `Refunds will not be issued where:`,
    extras: [
      {
        description: `A trip has commenced and was completed successfully.`,
      },
      {
        description: `Cancellations are made after dispatch of a driver/vehicle (a cancellation fee may apply).`,
      },
      {
        description: `Delays or disruptions are caused by circumstances outside truQ’s control (e.g., weather, traffic, strikes, or government restrictions).`,
      },
      {
        description: `Services or discounts obtained through third-party offers are non-refundable unless otherwise stated.`,
      },
    ],
  },
  {
    title: `Refund Process`,
    extras: [
      {
        description: `All refund requests must be submitted via the truQ app, website, or customer support within 7 business days of the transaction.`,
      },
      {
        description: `Refunds will be reviewed and, if approved, processed within 7 business days.`,
      },
      {
        description: `Refunds will be issued to the original method of payment unless otherwise agreed.`,
      },
    ],
  },
  {
    title: `Disputes`,
    description: `If you disagree with a charge or believe an error has occurred, please contact us immediately at`,
    footer: ` We will investigate and resolve disputes fairly and promptly.`,
    link: {
      href: `contact@mytruq.com`,
      type: LinkType.EMAIL,
      placement: PolicyLinkPlacement.DESCRIPTION,
    },
  },
  {
    title: `Changes to Policy`,
    description: `truQ reserves the right to update or modify this Refund Policy at any time. Any changes will be communicated on our website and will apply to future transactions.`,
  },
  {
    title: `Contact Us`,
    description: ` If you have any questions about this Refund Policy, please contact us at:`,
    footer: [`Phone No: +234 814 496 8867, Email:`],
    link: {
      href: `contact@mytruq.com`,
      type: LinkType.EMAIL,
      placement: PolicyLinkPlacement.FOOTER,
    },
  },
];
